import { AxiosResponseHeaders } from "axios";

interface LazyParams {
  rows: number;
  total: number;
  page: number;
  sortField: any | null;
  sortOrder: any | null;
  filters: [];
}

interface PaginationResponse {
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
}

const lazyParamsDefault: LazyParams = {
  rows: 5,
  page: 0,
  total: 0,
  sortField: null,
  sortOrder: null,
  filters: [],
};

const getPaginationValues = (headers: AxiosResponseHeaders): LazyParams => {
  const pagination = JSON.parse(headers["x-pagination"]) as PaginationResponse;

  if (pagination.currentPage === 0) {
    //pagination.currentPage = 1;
  }

  return {
    rows: pagination.itemsPerPage,
    total: pagination.totalItems,
    page: pagination.currentPage,
  } as LazyParams;
};

export { getPaginationValues, lazyParamsDefault };
